<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import Icon from '../../../common/components/Icon.svelte';

  type imageUploadState = 'new' | 'uploading' | 'done';

  export let state: imageUploadState = 'uploading';
  export let fileObject;
  export let disabled = false;

  let imageUrl = null;
  const dispatch = createEventDispatcher();
  let fileInputElement: HTMLInputElement;

  onMount(() => {
    if (state !== 'new') {
      imageUrl = URL.createObjectURL(fileObject.file);
    }
  });

  onDestroy(() => {
    if (imageUrl) {
      URL.revokeObjectURL(imageUrl);
    }
  });

  function clickHandler() {
    if (state === 'new' && !disabled) {
      fileInputElement.click();
    }
  }
  function fileInputChangeHandler(event) {
    dispatch('fileSelect', event.target.files);
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
  style:background={imageUrl ? `url(${imageUrl}) no-repeat center/contain` : ``}
  class="image-upload-item {state} {disabled && 'disabled'} id_{fileObject?.id}"
  on:click={clickHandler}
>
  {#if state === 'new'}
    <input
      multiple
      on:change={fileInputChangeHandler}
      accept="image/png, image/gif, image/jpeg"
      bind:this={fileInputElement}
      class="file-input"
      type="file"
      name="file"
      id="file_input_image"
    />
    <Icon type="font" glyph="add" size={24} />
  {:else if state === 'done'}
    <button on:click={() => dispatch('delete', fileObject.id)}>
      <Icon type="font" glyph="close" size={16} />
    </button>
  {:else}
    <section class="progress-wrapper">
      <Icon type="svg" glyph="progress-static" />
    </section>
  {/if}
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .image-upload-item {
    display: flex;
    flex-shrink: 0;
    background-color: $neutral-light-04;
    border: 1px solid $secondary-gray-02;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 88px;
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }

    &.new {
      border: 1px dashed $neutral-light-02;
      cursor: pointer;
    }
    &.done {
      position: relative;
    }

    input[type='file'] {
      display: none;
    }
    button {
      margin: 0;
      border: none;
      color: $icon-only-icon-blue;
      background-color: $primary-white;
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(40%, -40%);
      box-shadow: 0px 4px 12px rgba(188, 188, 188, 0.6);
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .progress-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background-color: rgba(14, 29, 163, 0.4);

      :global(img) {
        width: 24px;
        height: 24px;
        animation: rotate 2s infinite linear;
      }
    }
    @keyframes rotate {
      0% {
        transform: rotateZ(0deg);
      }
      100% {
        transform: rotateZ(360deg);
      }
    }
  }
</style>
